<template>
  <div class="col-sm-12 p-1" @click.stop="null">
    <h3 class="text-center">
      {{ stationUpdate.name }}
    </h3>
    <div class="col-sm-12 editor-form">
      <div v-if="isObserver">
          <span class="span-title p-1">{{ $t('material_station.name') }}</span>
          <input
              v-model="stationUpdate.name"
              type="text"
              class="form-control form-control-sm"
              :class="{ 'is-valid': stationUpdate.name?.trim() !== '', 'is-invalid': stationUpdate.name?.trim() === '' }"
          />
          <coordinate-editor
              v-model="stationUpdate.location"
              size="sm"
              :point-type="MATERIAL_STATION"
              :show-buttons="false"
              :title="$t('material_station.location')"
          />
      </div>
      <hr>
      <material-list
        v-model="stationUpdate.station_materials"
        :is-observer="isObserver"
        :is-worker="isWorker"
      />
      <hr>
      <span class="span-title p-1">{{ $t('material_station.scales') }}</span>
      <scale-list
          v-if="stationUpdate && stationUpdate.station_scales"
          v-model="stationUpdate.station_scales"
          :editable="isObserver || isWorker"
      />
      <hr>
      <div class="button-container pt-3 mb-0">
        <button
          :disabled="disabled"
          class="btn btn-sm btn-secondary form-button"
          @click.stop="$emit('cancel')"
        >
          <span>{{ $t('common.cancel') }}</span>
        </button>
        <button
          v-if="isObserver || isWorker"
          :disabled="!canSubmit"
          class="btn btn-sm btn-success form-button"
          @click.stop="$emit('closeAndUpdate', stationUpdate)"
        >
          <span>{{ $t('common.save') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CoordinateEditor from "@/components/CoordinateEditor";
import {mapHelper} from '../../mixins/MapMixin';
import MaterialList from "@/components/materials/station/MaterialList";
import ScaleList from "@/components/materials/station/ScaleList";
import {toRaw} from "vue";

export default {
    name: "MaterialStationEditor",
    components: {ScaleList, CoordinateEditor, MaterialList},
    mixins: [mapHelper],
    props: {
        station: {
            type: Object
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        isWorker: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            stationUpdate: null
        }
    },
    emits: ['close', 'edit'],
    computed: {
        canSubmit() {
            return this.validateValues() && !this.disabled
        }
    },
    created() {
        this.stationUpdate = toRaw(this.station)
    },
    methods: {
        validateValues() {
            // Check if station name exists
            if (this.stationUpdate.name == null || this.stationUpdate.name.trim() === '') {
                return false
            }
            // Check for empty materials
            if (this.stationUpdate.station_materials) {
                let invalidItem = this.stationUpdate.station_materials.find(item => item.material === undefined || item.type_test_code === undefined || item.type_test_code.length < 1)
                if (invalidItem) {
                    return false
                }
            }
            // Check for empty scales
            if (this.stationUpdate.station_scales) {
                let invalidItem = this.stationUpdate.station_scales.find(item => !item.name || !item.scale_id)
                if (invalidItem) {
                    return false
                }
            }
            return true
        }
    }

}
</script>
